module.exports = __webpack_public_path__ + "img/gift.96e6bcdc.svg";